'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function noop() {}
exports.noop = noop;
